import { useAppQuery } from "~/hooks/useAppQuery"
import { topicContentQueryKeys } from "../query-keys"
import { getTopicContent } from "../server/topic.functions"

export function useTopicContent(id: number) {
  return useAppQuery({
    queryKey: topicContentQueryKeys(id),
    queryFn: () => getTopicContent({ data: { id } }),
    errorMessage: "Не удалось загрузить контент темы",
  })
}
